import { useSignIn } from './signIn'

async function getMd5Password(password: string) {
  const { default: md5 } = await import('md5')
  return md5(password)
}

export function useEmailSignIn(onOk?: () => void) {
  const { runAsync, loading } = useSignIn()
  const router = useRouter()

  const handleSignIn = async (
    values:
      | { email: string; password: string }
      | { email: string; md5Password: string },
  ) => {
    if (loading) {
      return
    }

    const internalValues =
      'md5Password' in values
        ? values
        : {
            email: values.email,
            md5Password: await getMd5Password(values.password),
          }

    const result = await runAsync('system-user', {
      email: internalValues.email,
      password: internalValues.md5Password,
      redirect: false,
    })

    if (!result?.ok) {
      // hook 底层已做消息提示
      return
    }

    if (onOk) {
      onOk()
      return
    }

    const { redirect } = router.query
    if (redirect && typeof redirect === 'string') {
      router.push(redirect)
    } else {
      // 不一定有 dashboard 页面 请根据实际情况修改
      router.push('/')
    }
  }

  return {
    handleSignIn,
    loading,
  }
}
